import { useMemo } from "react";
import { useFormContext } from "../contexts/FormContext";
import { FormValues } from "../../Interface/scheduler/form";
import { AppConstants } from "../../constants/constant";

export const useBusinessNameVisibility = (fieldId: string): boolean => {
  const { formValues } = useFormContext();

  return useMemo(() => {
    return isBusinessNameHidden(fieldId, formValues);
  }, [fieldId, formValues?.conceptCode, formValues?.servicetype]);
};

/**
 * Pure utility to check if business name should be hidden.
 * Use this in non-hook contexts (validation, etc).
 */
export function isBusinessNameHidden(
  fieldId: string,
  formValues: FormValues
): boolean {
  return (
    fieldId === AppConstants.BUSINESS_NAME &&
    formValues?.servicetype?.toLowerCase() ===
      AppConstants?.RESIDENTIAL_TEXT?.toLocaleLowerCase()
  );
}
